export default __webpack_public_path__ + "static/media/idan-roll.f46ced68.png";